module.exports = __webpack_public_path__ + "static/img/step4.6ddfc0bc.png";